import { supabase } from './supabase'

// Current Supabase user id, read synchronously from the stored session (for scoping local cache keys).
export function sessionUserId() {
  try {
    for (let i = 0; i < localStorage.length; i++) {
      const k = localStorage.key(i)
      if (k && k.startsWith('sb-') && k.endsWith('-auth-token')) {
        const v = JSON.parse(localStorage.getItem(k))
        const id = v?.user?.id || v?.currentSession?.user?.id
        if (id) return id
      }
    }
  } catch (e) {}
  return 'anon'
}
export const newConvId = () => Date.now().toString(36) + Math.random().toString(36).slice(2, 8)

export function threadMeta(messages) {
  const users = (messages || []).filter(m => m.role === 'user' && m.text)
  const first = users[0]?.text || ''
  let title = first.replace(/\s+/g, ' ').trim()
  if (title.length > 60) title = title.slice(0, 57).trim() + '\u2026'
  const refs = new Set()
  ;(messages || []).forEach(m => {
    if (m.role !== 'ai' || !m.text) return
    m.text.split('\n').forEach(line => {
      if (!/\u2713|\u2714/.test(line)) return
      const found = line.match(/\b[A-Z]{2,6}-\d{1,6}\b/g)
      if (found) found.forEach(r => refs.add(r))
      else refs.add('action')
    })
  })
  return { title: title || 'New chat', refs: [...refs].slice(0, 20), userCount: users.length }
}

export async function listThreads(clientId) {
  const { data, error } = await supabase.from('ai_threads')
    .select('id, title, action_refs, updated_at, created_at')
    .eq('client_id', String(clientId)).order('updated_at', { ascending: false }).limit(150)
  if (error) throw error
  return data || []
}
export async function getThread(id) {
  const { data, error } = await supabase.from('ai_threads').select('*').eq('id', id).maybeSingle()
  if (error) throw error
  return data
}
// Update keeps a renamed title; insert sets the title from the first question.
export async function saveThread({ id, clientId, messages }) {
  const meta = threadMeta(messages)
  if (!meta.userCount || !clientId) return null
  const body = { messages: (messages || []).slice(-200), action_refs: meta.refs, updated_at: new Date().toISOString() }
  const { data: upd, error: e1 } = await supabase.from('ai_threads').update(body).eq('id', id).select('id')
  if (e1) throw e1
  if (upd && upd.length) return upd[0]
  const { error: e2 } = await supabase.from('ai_threads').insert({ id, client_id: String(clientId), title: meta.title, ...body })
  if (e2) throw e2
  return { id }
}
export async function renameThread(id, title) {
  const { error } = await supabase.from('ai_threads').update({ title: String(title).slice(0, 120) }).eq('id', id)
  if (error) throw error
}
export async function deleteThread(id) {
  const { error } = await supabase.from('ai_threads').delete().eq('id', id)
  if (error) throw error
}
